<div class="container-logoadv" [attr.id]="containerId">
  <span class="logoAdv" *ngIf="logoAdv">
    <img [src]="logoAdv" class="img-user img-fluid pl-1 pr-2 d-block m-auto"
    alt="logoAzienda">
  </span>
  <div class="info-logoadv">
    <h5>{{ iter?.agency?.name }}</h5>

    <div class="other-info--logoadv">
      <h6 *ngIf="iter?.agency?.telephone">
        <a class="agency-contact-link" [href]="'tel:' + sanitizeTelephoneForLink(iter.agency.telephone)"
          [attr.aria-label]="('COMMON.TEL' | translate) + ': ' + iter.agency.telephone"
          [title]="'COMMON.TEL' | translate">
          <em class="fas fa-phone"></em> <span class="agency-contact-text">{{ iter.agency.telephone }}</span>
        </a>
      </h6>

      <h6 *ngIf="iter?.agency?.email">
        <a class="agency-contact-link" [href]="'mailto:' + iter.agency.email"
          [attr.aria-label]="('COMMON.EMAIL' | translate) + ': ' + iter.agency.email"
          [title]="'COMMON.EMAIL' | translate">
          <em class="fas fa-envelope"></em> <span class="agency-contact-text">{{ iter.agency.email }}</span>
        </a>
      </h6>
      <h6>{{ "HOME.LASTUPDATE" | translate }} {{lastUpdate | localizedDate: 'dd-MM-yyyy HH:mm'}}</h6>
      <h6 *ngIf="iter?.agency?.commission && consolidator === 'AMG' && isTravelAgency">{{ "HOME.COMMISSION" | translate }}: {{ iter?.agency?.commission }}%</h6>
    </div>
  </div>
</div>
